module.exports = __webpack_public_path__ + "static/brascol-colecao-inverno-b568ec0aa2f70f2de6c879490a7d0365.jpg";